import React, { useEffect } from 'react';
import { useParams } from 'react-router';

import { useGetAppConfigQuery } from 'app/api/mainApi';
import SeekerAccount from './SeekerAccount';
import AdvisorAccount from './AdvisorAccount';
import AppBody from 'app/components/layout/AppBody';

import { userIsSeeker, userIsAdvisor } from 'app/helpers/whitelistHelpers';
import { useUseUserOffersMutation } from 'app/features/account/api/accountApi';

const AccountContainer = () => {
  const { data: appConfig } = useGetAppConfigQuery();
  const currentUser = appConfig?.current_user;
  const { offerHash, tab } = useParams();

  const [useUserOffers] = useUseUserOffersMutation();

  // on initial load, check if they were trying to redeem an offer
  // and if so, redeem it
  useEffect(() => {
    if (offerHash) useUserOffers(offerHash);
  }, []);

  let content = null;
  if (userIsSeeker(currentUser)) {
    content = (<SeekerAccount appConfig={appConfig} tab={tab} />);
  } else if (userIsAdvisor(currentUser)) {
    content = (<AdvisorAccount appConfig={appConfig} />);
  }

  return (
    <AppBody>
      {content}
    </AppBody>
  );
};

export default AccountContainer;
